export interface VehicleTransmission {
    id: number;
    name: string;
}

export const VEHICLE_TRANSMISSIONS: VehicleTransmission[] = [
    { id: 0, name: "Empty" },
    { id: 1, name: "Manual" },
    { id: 2, name: "SemiAutomatic" },
    { id: 3, name: "FullyAutomatic" },
    { id: 4, name: "TorqueConverter" },
    { id: 5, name: "Hydrostatic" },
    { id: 6, name: "Other" },
    { id: 7, name: "Automated" }
];